import React from 'react';
import { FaBuilding, FaMoneyBillWave } from 'react-icons/fa';

const FLOW_TABS = [
  {
    id: 'company',
    icon: FaBuilding,
    label: 'Company Account',
    desc: 'Bank payments & GST from franchise stores',
  },
  {
    id: 'cash',
    icon: FaMoneyBillWave,
    label: 'Cash in Hand',
    desc: 'Physical cash handed to field employees',
  },
];

export default function FlowSubTabs({ value, onChange }) {
  return (
    <div className="finance-subtabs finance-subtabs--cards" role="tablist" aria-label="Money flow type">
      {FLOW_TABS.map((tab) => {
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={value === tab.id}
            className={`finance-subtab-card ${value === tab.id ? 'active' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            <span className="finance-subtab-card-top">
              <Icon className="finance-subtab-card-icon" aria-hidden="true" />
              {tab.label}
            </span>
            <span className="finance-subtab-card-desc">{tab.desc}</span>
          </button>
        );
      })}
    </div>
  );
}
